export default __webpack_public_path__ + "static/media/logo-small.ebe8ae6c.svg";